import { ComparisonOperatorEnum } from "../enums/ComparisonOperatorEnum";
import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";

export class SoftwareVersionsSubset {
    updateType: UpdateTypeEnum = UpdateTypeEnum.Unknown;
    name: string = null;
    versions: string[] = [];
    comparisonOperator: ComparisonOperatorEnum = ComparisonOperatorEnum.EqualTo;

    public parse(obj: any) {
        if (obj.UpdateType != null && Object.values(UpdateTypeEnum).includes(obj.UpdateType)) this.updateType = obj.UpdateType;

        if (obj.Name) this.name = obj.Name;

        if (obj.Versions && obj.Versions.length > 0) {
            obj.Versions.forEach((v) => {
                this.versions.push(v);
            });
        }

        if (obj.ComparisonOperator != null && Object.values(ComparisonOperatorEnum).includes(obj.ComparisonOperator)) this.comparisonOperator = obj.ComparisonOperator;
    }

    public clone(): SoftwareVersionsSubset {
        let result = new SoftwareVersionsSubset();

        result.updateType = this.updateType;
        result.name = this.name;
        result.versions = [...this.versions];
        result.comparisonOperator = this.comparisonOperator;

        return result;
    }
}
